import React from 'react';
import styled from '@emotion/styled';
import { darken } from 'polished';

const StyledFilterMenu = styled.div`
  display: flex;
  flex-shrink: 1;
  margin: 0 auto;
  padding-bottom: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.backgroundDark};
  border: 1px solid ${props => props.theme.divider};
`;

const Tag = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  background-color: ${props =>
    props.activeFilter ? darken(0.3, props.color || '#aaa') : 'transparent'};
  color: white;
  margin: 2px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  min-width: 64px;
  max-width: 128px;
  padding: 0 2px;
  border: 1px solid ${props => (props.activeFilter ? props.color || '#444' : props.color || '#444')};
  :hover {
    border: 1px solid #fff;
  }

  span {
    box-sizing: border-box;
    width: 100%;
    margin: 0px 0px;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin: 2px;
  display: inline-block;
`;

const TagTitle = styled.div`
  text-align: center;
  font-weight: bold;
  width: 100%;
  color: white;
  padding: 2px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const TagBox = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 0;
`;

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-flow: row wrap;
  margin: 0px auto;
`;

const FilterMenu = ({ stats, filterStat, filters, onFilterToggled }) => {
  const isActiveFilter = statName => {
    if (filters.length === 0) return false;

    let foundFilter = false;

    filters.forEach(filter => {
      if (filter.values.includes(statName)) {
        foundFilter = true;
      }
    });

    return foundFilter;
  };

  return (
    <StyledFilterMenu>
      {stats &&
        stats.map(stat => {
          return (
            <div key={stat.name} >
              <TagTitle>
                Filter by&nbsp;
                {stat.displayName ? stat.displayName : filterStat.name}
              </TagTitle>
              <TagBox>
                <Tags>
                  {stat.options.map(statOption => {
                    return (
                      <Tag
                        key={statOption.name}
                        activeFilter={isActiveFilter(statOption.name)}
                        color={statOption.color}
                        onClick={() => onFilterToggled(stat.name, statOption.name)}
                      >
                        {statOption.uri && <Icon src={statOption.uri} />}
                        <span>{statOption.name}</span>
                      </Tag>
                    );
                  })}
                </Tags>
              </TagBox>
            </div>
          );
        })}
    </StyledFilterMenu>
  );
};

export default FilterMenu;
